<template>
  <v-app-bar
    app
    :height="$vuetify.breakpoint.mdAndUp ? 88 : 48"
    color="white"
  >
    <v-container
      fill-height
      mx-auto
      pa-0
    >
      <v-row align="center">
        <v-app-bar-nav-icon
          v-if="$vuetify.breakpoint.smAndDown"
          @click="$store.commit('toggleDrawer')"
        />
        <router-link to="/">
          <v-img
            :class="[$vuetify.breakpoint.mdAndDown && 'ml-auto']"
            :src="require('@/assets/logo.png')"
            contain
            class="mr-5"
            max-width="120"
            width="120"
          />
        </router-link>

        <div class="grow hidden-sm-and-down">
          <v-menu
            v-for="(item, i) in items"
            :key="i"
            v-model="item.model"
            attach
            close-delay="0"
            content-class="elevation-0"
            dark
            open-on-hover
            offset-y
            bottom
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                :input-value="item.model"
                color="primary"
                large
                text
                tile
                v-on="on"
              >
                <strong
                  :class="i + 1 === items.length ? 'font-weight-black' : ''"
                  class="text-capitalize"
                  v-text="item.text"
                />
              </v-btn>
            </template>
            <v-card
              color="rgba(44, 122, 144, .85)"
              tile
            >
              <div
                class="px-3 pt-3 font-weight-medium subheading"
                v-text="item.subtext"
              />
              <v-list
                dense
                class="transparent"
              >
                <component
                  :is="`core-partials-${item.children}`"
                  v-if="item.children"
                />
              </v-list>
            </v-card>
          </v-menu>
        </div>

        <v-text-field
          append-icon="mdi-magnify"
          class="hidden-sm-and-down"
          hide-details
          label="Search"
          outlined
          single-line
          style="max-width: 250px;"
        />
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  export default {
    computed: {
      items () {
        if (this.userIsAuthenticated) {
          return [
            {
              text: 'Join Live Classes',
              subtext: 'Join us!',
              children: 'liveClasses'
            },
            {
              text: 'On-Demand Library',
              subtext: "Let's dance!",
              children: 'videoTypes'
            },
            {
              text: 'Community',
              subtext: 'Dancing is more fun with friends',
              children: 'community'
            },
            {
              text: 'My Profile',
              subtext: 'Manage Account',
              children: 'myProfile'
            }
          ].map(item => {
            return Object.assign({}, item, { model: false })
          })
        } else {
          return []
        }
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    }
  }
</script>
